import { render, staticRenderFns } from "./IdeaSettingsPage.vue?vue&type=template&id=67037514"
import script from "./IdeaSettingsPage.vue?vue&type=script&lang=js"
export * from "./IdeaSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports